export default __webpack_public_path__ + "static/connectivity-9b99bc402fc2ae71348bf6a43e3e2fab.svg";